export const config = {
  colombia: {
    map: {
      initialZoom: 5,
      minZoom: 5,
      maxZoom: 20
    },
    "el-pozon": {
      aoi: {
        minZoom: 14,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 14,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 17,
        maxZoom: 21
      },
      sectors: {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-outlines": {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-labels": {
        minZoom: 15,
        maxZoom: 18
      },
      buildings: {
        minZoom: 14,
        maxZoom: 21
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 21
      },
      greenspaces: {
        minZoom: 14,
        maxZoom: 21
      },
      "drone-road-labels": {
        minZoom: 18,
        maxZoom: 21
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    },
    neiva: {
      aoi: {
        minZoom: 14,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 14,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 17,
        maxZoom: 21
      },
      sectors: {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-outlines": {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-labels": {
        minZoom: 15,
        maxZoom: 18
      },
      buildings: {
        minZoom: 14,
        maxZoom: 21
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 21
      },
      greenspaces: {
        minZoom: 14,
        maxZoom: 21
      },
      "drone-road-labels": {
        minZoom: 18,
        maxZoom: 21
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    }
  },
  peru: {
    map: {
      initialZoom: 4.8,
      minZoom: 4.8,
      maxZoom: 21
    },
    brena: {
      aoi: {
        minZoom: 14,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 14,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 17,
        maxZoom: 21
      },
      sectors: {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-outlines": {
        minZoom: 15,
        maxZoom: 17
      },
      "sector-labels": {
        minZoom: 15,
        maxZoom: 18
      },
      buildings: {
        minZoom: 14,
        maxZoom: 21
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 21
      },
      greenspaces: {
        minZoom: 14,
        maxZoom: 21
      },
      "drone-road-labels": {
        minZoom: 18,
        maxZoom: 21
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    },
    independencia: {
      aoi: {
        minZoom: 13,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 13,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 17,
        maxZoom: 21
      },
      sectors: {
        minZoom: 14,
        maxZoom: 17
      },
      "sector-outlines": {
        minZoom: 14,
        maxZoom: 17
      },
      "sector-labels": {
        minZoom: 14,
        maxZoom: 18
      },
      greenspaces: {
        minZoom: 13,
        maxZoom: 21
      },
      buildings: {
        minZoom: 13,
        maxZoom: 21
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 21
      },
      "drone-road-labels": {
        minZoom: 18,
        maxZoom: 21
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    }
  },
  paraguay: {
    map: {
      initialZoom: 5.8,
      minZoom: 5.8,
      maxZoom: 21
    },
    chacarita: {
      aoi: {
        minZoom: 13,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 13,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 16,
        maxZoom: 22
      },
      sectors: {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-outlines": {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-labels": {
        minZoom: 14,
        maxZoom: 18
      },
      buildings: {
        minZoom: 13,
        maxZoom: 22
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 22
      },
      greenspaces: {
        minZoom: 13,
        maxZoom: 22
      },
      "drone-road-labels": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-sequences": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 16,
        maxZoom: 22
      }
    },
    tacumbu: {
      aoi: {
        minZoom: 13,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 13,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 16,
        maxZoom: 22
      },
      sectors: {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-outlines": {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-labels": {
        minZoom: 14,
        maxZoom: 18
      },
      buildings: {
        minZoom: 13,
        maxZoom: 22
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 22
      },
      greenspaces: {
        minZoom: 13,
        maxZoom: 22
      },
      "drone-road-labels": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    }
  },
  indonesia: {
    map: {
      initialZoom: 4.5,
      minZoom: 3,
      maxZoom: 21
    },
    padang: {
      aoi: {
        minZoom: 11.8,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 11.8,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 16,
        maxZoom: 22
      },
      sectors: {
        minZoom: 13,
        maxZoom: 16
      },
      "sector-outlines": {
        minZoom: 13,
        maxZoom: 16
      },
      "sector-labels": {
        minZoom: 13,
        maxZoom: 18
      },
      buildings: {
        minZoom: 11.8,
        maxZoom: 22
      },
      "building-outlines": {
        minZoom: 15,
        maxZoom: 22
      },
      greenspaces: {
        minZoom: 11.8,
        maxZoom: 22
      },
      "drone-road-labels": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-sequences": {
        minZoom: 14,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 14,
        maxZoom: 22
      }
    }
  },
  mexico: {
    map: {
      initialZoom: 4.5,
      minZoom: 3,
      maxZoom: 21
    },
    juchitan: {
      aoi: {
        minZoom: 13,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 13,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 16,
        maxZoom: 22
      },
      sectors: {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-outlines": {
        minZoom: 14,
        maxZoom: 16
      },
      "sector-labels": {
        minZoom: 14,
        maxZoom: 18
      },
      buildings: {
        minZoom: 13,
        maxZoom: 22
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 22
      },
      greenspaces: {
        minZoom: 13,
        maxZoom: 22
      },
      "drone-road-labels": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    },
    "salina-cruz": {
      aoi: {
        minZoom: 12,
        maxZoom: 17
      },
      "aoi-outline": {
        minZoom: 12,
        maxZoom: 17
      },
      "drone-cover": {
        minZoom: 16,
        maxZoom: 22
      },
      sectors: {
        minZoom: 13,
        maxZoom: 16
      },
      "sector-outlines": {
        minZoom: 13,
        maxZoom: 16
      },
      "sector-labels": {
        minZoom: 13,
        maxZoom: 18
      },
      buildings: {
        minZoom: 12,
        maxZoom: 22
      },
      "building-outlines": {
        minZoom: 18,
        maxZoom: 22
      },
      greenspaces: {
        minZoom: 12,
        maxZoom: 22
      },
      "drone-road-labels": {
        minZoom: 16,
        maxZoom: 22
      },
      "mapillary-sequences": {
        minZoom: 17,
        maxZoom: 22
      },
      "mapillary-images": {
        minZoom: 17,
        maxZoom: 22
      }
    }
  }
};
